import React, { useRef, useState } from 'react';
import { useRecoilState } from 'recoil';
import { Container, Box, DataTable, Grid, TableState } from '@tq/ui-components';

import { DataTablePagination } from 'components';
import { OrganisationFilters } from './components';
import {
  manageOrganisationsPageNumberState,
  manageOrganisationsPageSizeState,
  mangeOrganisationsOrderByColumnState,
  mangeOrganisationsOrderByDescendingState,
} from 'store';
import { useParentOrganisations } from 'api';
import { useManageOrganisationColumns } from './hooks';
import { Organisation, Team } from 'types';
import { dataTableStyle } from '../../../../styles';
import { SortingRule } from 'react-table';

export const ManageOrganisations: React.FC = () => {
  const { data } = useParentOrganisations();
  const tableRef = useRef(null);
  const columns = useManageOrganisationColumns();
  const [orderBy, setOrderBy] = useRecoilState(mangeOrganisationsOrderByColumnState);
  const [orderByValue, setOrderByValue] = useRecoilState(
    mangeOrganisationsOrderByDescendingState
  );
  const [sortBy, setSortBy] = useState<SortingRule<Team>[]>([
    {
      id: orderBy,
      desc: orderByValue,
    },
  ]);

  const handleStateChange = (state: TableState<Organisation>) => {
    if (!state.filters.length && !state.sortBy.length) return;
    const newOrderByValue = state.sortBy?.[0]?.id;
    const newOrderByDescending = state.sortBy?.[0]?.desc ?? false;
    if (state.sortBy !== sortBy) {
      setSortBy(state.sortBy);
    }
    if (newOrderByValue) {
      setOrderBy(newOrderByValue);
      setOrderByValue(newOrderByDescending);
    }
  };

  return (
    <Container px={{ base: 0, lg: 4, xl: 0 }}>
      <Grid gridGap={5} mb='3rem' mt='1rem'>
        <OrganisationFilters />
        <Box sx={dataTableStyle}>
          <DataTable
            columns={columns}
            data={data?.parentOrganisations.items ?? []}
            onStateChange={handleStateChange}
            disableSortRemove={true}
            disablePagination={true}
            enableOverflowScrollingContainer={true}
            size='sm'
            whiteSpace='normal'
            sortBy={sortBy}
            manualSortBy={true}
          />
          <DataTablePagination
            paginationInfo={data?.paginationInfo}
            pageNumberState={manageOrganisationsPageNumberState}
            pageSizeState={manageOrganisationsPageSizeState}
            tableRef={tableRef}
            tableScrollHeaderOffset={167}
          />
        </Box>
      </Grid>
    </Container>
  );
};
